import { getStopApi } from "../../services/StopApi/StopApi";

export const getAuthorizationReportsCalomsactDataGrid = async ({
  commonParams,
  authorization,
}) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const json = response.data;
    return {
      isLoading: false,
      data: json,
    };
  }).catch((e) => alert(e));
};
